import Vue from 'vue';
import Router from 'vue-router';
import ErrorPage404 from '../pages/errorPage/errorPage404.vue';

// import ElectronicInvoice from './modules/electronicInvoice';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
    },
    {
      path: '/ssologin',
      name: '登录',
      meta: {
        title: '登录',
      },
      component: () => import('../pages/login/ssologin.vue'),
    },
    {
      path: '*',
      name: 404,
      component: ErrorPage404,
    },
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '../../../components/common/home.vue'),
      meta: {
        title: '自述文件',
      },
      children: [
        {
          path: '/403',
          component: () => import('../pages/errorPage/errorPage403.vue'),
          meta: {
            title: '403',
          },
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */
              '../pages/home/dashboard.vue'
            ),
          meta: {
            title: '首页',
          },
        },
        {
          path: '/eav3/:pages*',
          name: 'eaV3',
          component: () => import('../pages/micro/eav3/index.vue'),
          beforeEnter: (to, from, next) => {
            if (!to.params.pages) {
              next('/eav3/dashboard'); // 没有 `pages` 参数时跳转到默认页
            } else {
              next();
            }
          },
        },
        {
          path: '/systemMessages',
          name: 'systemMessages',
          component: () =>
            import(
              /* webpackChunkName: "systemMessages" */
              '../pages/home/systemMessages.vue'
            ),
          meta: {
            title: '系统消息',
          },
        },
        {
          path: '/productManage',
          name: 'productManage',
          component: () =>
            import(
              /* webpackChunkName: "login" */
              '../pages/product/productManage.vue'
            ),
          meta: {
            title: '商品管理',
          },
        },
        {
          path: '/sku',
          name: 'sku',
          component: () =>
            import(
              /* webpackChunkName: "login" */
              '../pages/product/skuProduct.vue'
            ),
          meta: {
            title: '单品管理',
          },
        },
        {
          path: '/productDetail',
          name: 'productDetail',
          component: () => import('../pages/product/productDetail.vue'),
          meta: {
            title: '商品详情',
          },
        },
        {
          path: '/productEdit',
          name: 'productEdit',
          component: () => import('../pages/product/productEdit.vue'),
          meta: {
            title: '商品编辑',
          },
        },
        {
          path: '/batchEdit',
          name: 'batchEdit',
          component: () => import('../pages/product/batchEdit.vue'),
          meta: {
            title: '批量修改',
          },
        },
        {
          path: '/batch',
          name: 'batch',
          component: () =>
            import(
              /* webpackChunkName: "login" */
              '../pages/product/batchManage.vue'
            ),
          meta: {
            title: '批量管理',
          },
        },
        {
          path: '/freightRules',
          name: 'freightRules',
          component: () => import('../pages/product/freightRules.vue'),
          meta: {
            title: '运费规则设置',
          },
        },
        {
          path: '/freightRulesAdd',
          name: 'freightRulesAdd',
          component: () => import('../pages/product/freightRulesAdd.vue'),
          meta: {
            title: '新增运费规则',
          },
        },
        {
          path: '/brandManage',
          name: 'brandManage',
          component: () => import('../pages/product/brand/brandManage.vue'),
          meta: { title: '品牌管理' },
        },
        {
          path: '/brandProtocol',
          name: 'brandProtocol',
          component: () => import('../pages/product/brand/brandProtocol.vue'),
          meta: { title: '品牌管理' },
        },
        {
          path: '/brandEdit',
          name: 'brandEdit',
          component: () => import('../pages/product/brand/brandEdit.vue'),
          meta: { title: '品牌编辑' },
        },
        {
          path: '/brandApply',
          name: 'brandApply',
          component: () => import('../pages/product/brand/brandApply.vue'),
          meta: { title: '品牌申请' },
        },
        {
          path: '/brandDetail',
          name: 'brandDetail',
          component: () => import('../pages/product/brand/brandDetail.vue'),
          meta: { title: '品牌详情' },
        },
        {
          path: '/agreementPrice',
          name: 'agreementPrice',
          component: () => import('../pages/product/agreementPrice.vue'),
          meta: {
            title: '协议价管理',
          },
        },
        {
          path: '/agreementPriceAdd',
          name: 'agreementPriceAdd',
          component: () => import('../pages/product/agreementAdd.vue'),
          meta: {
            title: '协议新增',
          },
        },
        {
          path: '/orderManage',
          name: 'orderManage',
          component: () => import('../pages/order/orderManage.vue'),
          meta: {
            title: '我的销售订单',
          },
        },
        {
          path: '/invoiceList',
          name: 'InvoiceList',
          component: () => import('../pages/order/invoiceList.vue'),
          meta: {
            title: '查看发货单',
          },
        },
        // {
        //   path: '/invoiceListDetail',
        //   name: 'InvoiceListDetail',
        //   component: () =>
        //     import('../pages/order/invoiceListDetail.vue'),
        //   meta: {
        //     title: '查看发货单详情',
        //   },
        // },
        // 物流 迭代
        {
          path: '/invoiceListDetail',
          name: 'InvoiceListDetail',
          component: () => import('../pages/order/invoiceListDetailPurchase.vue'),
          meta: {
            title: '查看发货单详情',
          },
        },
        {
          path: '/deliveryManagement',
          name: 'deliveryManagement',
          component: () => import('../pages/order/orderManage.vue'),
          meta: {
            title: '发货管理',
          },
        },

        {
          path: '/invoiceDetail',
          name: 'invoiceDetail',
          component: () => import('../pages/order/invoiceDetail.vue'),
          meta: {
            title: '发票详情',
          },
        },

        {
          path: '/orderDeliverDetail',
          name: 'orderDeliverDetail',
          component: () => import('../pages/order/orderDeliverDetail.vue'),
          meta: {
            title: '发货详情',
          },
        },
        {
          path: '/orderDetailOrConfirm',
          name: 'orderDetailOrConfirm',
          component: () => import('../pages/order/orderDetailOrConfirm.vue'),
          meta: {
            title: '订单详情',
          },
        },
        {
          path: '/HDOrderDetailOrConfirm',
          name: 'HDOrderDetailOrConfirm',
          component: () => import('../pages/order/HDOrderDetailOrConfirm.vue'),
          meta: {
            title: '订单详情',
          },
        },

        {
          path: '/orderChange',
          name: 'orderChange',
          component: () => import('../pages/order/orderChange.vue'),
          meta: {
            title: '订单变更',
          },
        },
        {
          path: '/selfConfigShipperMaintain',
          name: 'selfConfigShipperMaintain',
          component: () => import('../pages/order/selfConfigShipperMaintain.vue'),
          meta: {
            title: '自配物流发货人维护',
          },
        },
        {
          path: '/orderManageCaiGou',
          name: 'purchaseOrderManage',
          component: () => import('../pages/order/purchaseOrderManage.vue'),
          meta: {
            title: '采购数据统计',
          },
        },
        {
          path: '/directedInquiry',
          name: 'DirectedInquiry',
          component: () => import('../pages/order/enquiryPrice/directedInquiry.vue'),
          meta: {
            title: '定向询价',
          },
        },
        {
          path: '/openInquiry',
          name: 'OpenInquiry',
          component: () => import('../pages/order/enquiryPrice/openInquiry.vue'),
          meta: {
            title: '公开询价',
          },
        },
        // havePrice
        {
          path: '/havePrice',
          name: 'HavePrice',
          component: () => import('../pages/order/enquiryPrice/havePrice.vue'),
          meta: {
            title: '已报价',
          },
        },
        {
          path: '/seeDetails',
          name: 'seeDetails',
          component: () => import('../pages/order/enquiryPrice/seeDetails.vue'),
          meta: {
            title: '询比价详情',
          },
        },
        {
          path: '/huadongSeeDetails',
          name: 'huadongSeeDetails',
          component: () => import('../pages/order/huadongEnquiryPrice/seeDetails.vue'),
          meta: {
            title: '华东询比价详情',
          },
        },
        //
        {
          path: '/negotiationRemark',
          name: 'negotiationRemark',
          component: () => import('../pages/order/enquiryPrice/negotiationRemark.vue'),
          meta: {
            title: '磋商详情',
          },
        },

        {
          path: '/invocieManage',
          name: 'invocieManage',
          component: () => import('../pages/order/invocieManage.vue'),
          meta: {
            title: '开票管理',
          },
        },
        {
          path: '/rateManage',
          name: 'rateManage',
          component: () => import('../pages/order/rateManage.vue'),
          meta: {
            title: '评价管理',
          },
        },

        {
          path: '/accountOrder',
          name: 'AccountOrder',
          component: () => import('../pages/order/account/index.vue'),
          meta: {
            title: '对账管理',
          },
        },
        {
          path: '/accountDetail',
          name: 'AccountOrder',
          component: () => import('../pages/order/account/accountDetail.vue'),
          meta: {
            title: '对账详情',
          },
        },
        {
          path: '/createProduct',
          name: 'createProduct',
          component: () => import('../pages/product/createProducts/createProduct.vue'),
          meta: {
            title: '发布商品',
          },
        },
        // {
        //   path: "/createProductDetail",
        //   name: "createProductDetail",
        //   component: () => import("../pages/product/createProducts/productDetail.vue"),
        //   meta: { title: "商品修改" },
        // },
        {
          path: '/createProductsMain',
          name: 'createProductsMain',
          component: () => import('../pages/product/createProducts/createProductsMain.vue'),
          meta: {
            title: '商品编辑',
          },
        },
        {
          path: '/createProductsFirst',
          name: 'createProductsFirst',
          component: () => import('../pages/product/createProducts/createProductsFirst.vue'),
        },
        {
          path: '/createProductsSec',
          name: 'createProductsSec',
          component: () => import('../pages/product/createProducts/createProductsSec.vue'),
          meta: {
            title: '商品新增',
          },
        },
        {
          path: '/createProductsThird',
          name: 'createProductsThird',
          component: () => import('../pages/product/createProducts/createProductsThird.vue'),
          meta: {
            title: '商品新增',
          },
        },
        {
          path: '/createBatchProducts',
          name: 'createBatchProducts',
          component: () => import('../pages/product/createProducts/createBatchProducts.vue'),
          meta: {
            title: '商品批量发布',
          },
        },
        {
          path: '/logisticsManage',
          name: 'logisticsManage',
          component: () => import('../pages/order/logisticsManage.vue'),
          meta: {
            title: '维护自配物流信息',
          },
        },
        {
          path: '/exclusivePurchase',
          name: 'exclusivePurchase',
          meta: {
            title: '专属采购',
          },
          component: () => import('../pages/exclusivePurchase/index.vue'),
        },
        {
          path: '/reviewPurchase',
          name: 'reviewPurchase',
          meta: {
            title: '专属采购预览',
          },
          component: () => import('../pages/exclusivePurchase/reviewPurchase.vue'),
        },

        // {
        //   path: '/exclusiveMall',
        //   name: 'exclusiveMall',
        //   meta: {title: '我的采购专属商城'},
        //   component: () => import ('../pages/exclusivePurchase/exclusiveMall.vue')
        // },
        {
          path: '/afterSaleManageAffirm',
          name: 'afterSaleManageAffirm',
          component: () => import('../pages/order/afterSaleManageAffirm.vue'),
          meta: {
            title: '售后订单查看并确认',
          },
        },
        {
          path: '/afterSaleManage',
          name: 'afterSaleManage',
          component: () => import('../pages/order/afterSaleManage.vue'),
          meta: {
            title: '售后申请列表',
          },
        },
        {
          path: '/agreementManage',
          name: 'agreementManage',
          component: () => import('../pages/agreement/cgAgreementManage.vue'),
          meta: {
            title: '采购框架协议',
          },
        },
        {
          path: '/agreementAdd',
          name: 'agreementAdd',
          component: () => import('../pages/agreement/agreementAdd.vue'),
          meta: {
            title: '协议新增',
          },
        },
        {
          path: '/agreementEdit',
          name: 'agreementEdit',
          component: () => import('../pages/agreement/agreementEdit.vue'),
          meta: {
            title: '协议编辑',
          },
        },
        {
          path: '/agreementDetail',
          name: 'agreementDetail',
          component: () => import('../pages/agreement/agreementDetail.vue'),
          meta: {
            title: '协议详情',
          },
        },
        {
          path: '/institutionManage',
          name: 'institutionManage',
          component: () => import('../pages/authority/institutionManage.vue'),
          meta: {
            title: '组织机构管理',
          },
        },
        {
          path: '/institutionImport',
          name: 'institutionImport',
          component: () => import('../pages/authority/importInstitution.vue'),
          meta: {
            title: '员工导入',
          },
        },
        {
          path: '/assignRole',
          name: 'assignRole',
          component: () => import('../pages/authority/assignRole.vue'),
          meta: {
            title: '分配角色',
          },
        },
        {
          path: '/assignDataAuth',
          name: 'assignDataAuth',
          component: () => import('../pages/authority/assignDataAuth.vue'),
          meta: {
            title: '分配数据权限',
          },
        },
        {
          path: '/roleManage',
          name: 'roleManage',
          component: () => import('../pages/authority/roleManage.vue'),
          meta: {
            title: '角色管理',
          },
        },
        {
          path: '/assignFunctionAuth',
          name: 'assignFunctionAuth',
          component: () => import('../pages/authority/assignFunctionAuth.vue'),
          meta: {
            title: '分配功能权限',
          },
        },
        {
          path: '/userManage',
          name: 'userManage',
          component: () => import('../pages/authority/userManage.vue'),
          meta: {
            title: '员工管理',
          },
        },
        {
          path: '/removeDepartment',
          name: 'removeDepartment',
          component: () => import('../pages/authority/removeDepartment.vue'),
          meta: {
            title: '转移部门',
          },
        },
        {
          path: '/salesTerritoryManage',
          name: 'salesTerritoryManage',
          component: () => import('../pages/product/salesTerritoryManage'),
          meta: {
            title: '销售区域设置',
          },
        },
        {
          path: '/purchaseAudit',
          name: 'purchaseAudit',
          component: () => import('../pages/company/purchaseAudit'),
          meta: {
            title: '采购审批管理',
          },
        },
        {
          path: '/productDirectoryApply',
          name: 'productDirectoryApply',
          component: () => import('../pages/company/productDirectoryApply'),
          meta: {
            title: '产品目录申请',
          },
        },
        {
          path: '/productDirectoryManage',
          name: 'productDirectoryManage',
          component: () => import('../pages/company/productDirectoryManage'),
          meta: {
            title: '产品目录管理',
          },
        },
        {
          path: '/transactionModeManage',
          name: 'transactionModeManage',
          component: () => import('../pages/company/transactionModeManage'),
          meta: {
            title: '交易参数设置',
          },
        },
        {
          path: '/agreementConfirm',
          name: 'agreementConfirm',
          component: () => import('../pages/agreement/agreementConfirm.vue'),
          meta: {
            title: '协议价确认',
          },
        },
        {
          path: '/createPurchaseAudit',
          name: 'createPurchaseAudit',
          component: () => import('../pages/company/createPurchaseAudit'),
          meta: {
            title: '新增采购审批',
          },
        },
        {
          path: '/editPurchaseAudit',
          name: 'editPurchaseAudit',
          component: () => import('../pages/company/editPurchaseAudit'),
          meta: {
            title: '编辑采购审批',
          },
        },
        {
          path: '/approverEdit',
          name: 'approverEdit',
          component: () => import('../pages/company/approverEdit'),
          meta: {
            title: '采购审批节点设置',
          },
        },
        {
          path: '/editApproverEdit',
          name: 'editApproverEdit',
          component: () => import('../pages/company/editApproverEdit'),
          meta: {
            title: '采购审批节点设置',
          },
        },
        {
          path: '/goodsMaintenance',
          name: 'goodsMaintenance',
          component: () => import('../pages/product/goodsMaintenance'),
          meta: {
            title: '商品维护',
          },
        },
        {
          path: '/goodsMaintenance/nonstandardDetail',
          name: 'nonstandardDetail',
          component: () => import('../pages/product/goodsMaintenance/nonstandardDetail'),
          meta: {
            title: '非标商品详情',
          },
        },
        {
          path: '/goodsMaintenance/nonstandardEdit',
          name: 'nonstandardEdit',
          component: () => import('../pages/product/goodsMaintenance/nonstandardEdit'),
          meta: {
            title: '非标商品编辑',
          },
        },
        {
          path: '/shAgreementManage',
          name: 'shAgreementManage',
          component: () => import('../pages/agreement/agreementManage.vue'),
          meta: {
            title: '石化销售协议管理',
          },
        },
        {
          path: '/sellAgreement',
          name: 'sellAgreement',
          component: () => import('../pages/agreement/sellAgreement/index.vue'),
          meta: {
            title: '协议详情',
          },
        },
        {
          path: '/scAgreementManage',
          name: 'scAgreementManage',
          component: () => import('../pages/agreement/agreementManage.vue'),
          meta: {
            title: '销售协议管理',
          },
        },
        {
          path: '/maintenanceGoods',
          name: 'maintenanceGoods',
          component: () => import('../pages/agreement/goodsMaintenance.vue'),
          meta: {
            title: '维护协议商品',
          },
        },
        {
          path: '/brandMallMgt',
          name: 'brandMallMgt',
          component: () => import('../pages/brandMall/brandMallMgt.vue'),
          meta: {
            title: '销售商城配置',
          },
        },
        {
          path: '/store',
          name: 'store',
          component: () => import('../pages/brandMall/store.vue'),
          meta: {
            title: '店铺管理',
          },
        },
        {
          path: '/storeAudit',
          name: 'storeAudit',
          component: () => import('../pages/brandMall/storeAudit.vue'),
          meta: {
            title: '店铺审核',
          },
        },
        {
          path: '/addBrandMall',
          name: 'addBrandMall',
          component: () => import('../pages/brandMall/addBrandMall.vue'),
          meta: {
            title: '品牌商城',
          },
        },
        {
          path: '/contentTemplate',
          name: 'contentTemplate',
          component: () => import('../pages/brandMall/contentTemplate.vue'),
          meta: {
            title: '内容模板',
          },
        },
        {
          path: '/sopspecification',
          name: 'sopspecification',
          component: () => import('../pages/product/sopspecification.vue'),
          meta: {
            title: '规格属性申请',
          },
        },
        {
          path: '/personnelpracticelog',
          name: 'personnelpracticelog',
          component: () => import('../pages/logsystem/personnelpracticelog.vue'),
          meta: {
            title: '人员操作日志',
          },
        },
        {
          path: '/RoleActionLog',
          name: 'RoleActionLog',
          component: () => import('../pages/logsystem/RoleActionLog.vue'),
          meta: {
            title: '角色操作日志',
          },
        },
        {
          path: '/configuration',
          name: 'configuration',
          component: () => import('../pages/logsystem/configuration.vue'),
          meta: {
            title: '配置管理日志',
          },
        },
        {
          path: '/ProtocolOperationLog',
          name: 'ProtocolOperationLog',
          component: () => import('../pages/logsystem/ProtocolOperationLog.vue'),
          meta: {
            title: '协议操作日志',
          },
        },
        {
          path: '/orderForm',
          name: 'orderForm',
          component: () => import('../pages/logsystem/orderForm.vue'),
          meta: {
            title: '订单操作日志',
          },
        },
        {
          path: '/commodity',
          name: 'commodity',
          component: () => import('../pages/logsystem/commodity.vue'),
          meta: {
            title: '商品操作日志',
          },
        },
        {
          path: '/maintenanceAffiliation',
          name: 'maintenanceAffiliation',
          component: () => import('../pages/insititution/maintenanceAffiliation.vue'),
          meta: {
            title: '维护企业隶属关系',
          },
        },
        {
          path: '/supplyServiceCapabilityInfo',
          name: 'supplyServiceCapabilityInfo',
          iframeComponent: () => import('../pages/nesting/supplyServiceCapabilityInfo.vue'),
          meta: {
            title: '供应服务能力信息',
          },
        },
        {
          path: '/affiliation',
          name: 'affiliation',
          iframeComponent: () => import('../pages/nesting/affiliation.vue'),
          meta: {
            title: '股权占比',
          },
        },
        {
          path: '/majorEventsReporting',
          name: 'majorEventsReporting',
          iframeComponent: () => import('../pages/nesting/majorEventsReporting.vue'),
          meta: {
            title: '重大事项报备',
          },
        },
        {
          path: '/noticeRectification',
          name: 'noticeRectification',
          iframeComponent: () => import('../pages/nesting/noticeRectification.vue'),
          meta: {
            title: '整改通知书',
          },
        },
        {
          path: '/jobsPromptInfo',
          name: 'jobsPromptInfo',
          iframeComponent: () => import('../pages/nesting/jobsPromptInfo.vue'),
          meta: {
            title: '工作提示信息',
          },
        },
        {
          path: '/contractManagement',
          name: 'contractManagement',
          iframeComponent: () => import('../pages/nesting/contractManagement.vue'),
          meta: {
            title: '合同管理',
          },
        },
        {
          path: '/productDirectory',
          name: 'productDirectory',
          iframeComponent: () => import('../pages/nesting/productDirectoryInfo.vue'),
          meta: {
            title: '石化销售产品目录',
          },
        },
        {
          path: '/worstEvaluationInfo',
          name: 'worstEvaluationInfo',
          iframeComponent: () => import('../pages/nesting/worstEvaluationInfo.vue'),
          meta: {
            title: '最差评价',
          },
        },
        {
          path: '/addressManagement',
          name: 'addressManagement',
          iframeComponent: () => import('../pages/nesting/addressManagement.vue'),
          meta: {
            title: '地址管理',
          },
        },
        {
          path: '/invoiceManagement',
          name: 'invoiceManagement',
          iframeComponent: () => import('../pages/nesting/invoiceManagement.vue'),
          meta: {
            title: '开票信息维护',
          },
        },
        {
          path: '/qualificationInformation',
          name: 'qualificationInformation',
          iframeComponent: () => import('../pages/nesting/qualificationInformation.vue'),
          meta: {
            title: '资质信息',
          },
        },
        /* {
          path: '/ratingMaintenance',
          name: 'ratingMaintenance',
          iframeComponent: () => import('../pages/nesting/iframeNew.vue'),
          meta: {
            title: '企业信用评价维护',
          },
        }, */
        {
          path: '/ratingMaintenance',
          name: 'ratingMaintenance',
          iframeComponent: () => import('../pages/nesting/ratingMaintenance.vue'),
          meta: {
            title: '企业信用评价维护',
          },
        },
        {
          path: '/toPayFeedbackList',
          name: 'toPayFeedbackList',
          iframeComponent: () => import('../pages/nesting/toPayFeedbackList.vue'),
          meta: {
            title: '逾期未交费通知',
          },
        },

        {
          path: '/enquiryAuth',
          name: 'enquiryAuth',
          iframeComponent: () => import('../pages/nesting/enquiryAuth.vue'),
          meta: {
            title: '询比价设置',
          },
        },
        {
          path: '/manageInfo',
          name: 'manageInfo',
          iframeComponent: () => import('../pages/nesting/manageInfo.vue'),
          meta: {
            title: '管理信息',
          },
        },
        {
          path: '/collectionAccount',
          name: 'collectionAccount',
          component: () => import('../pages/nesting/collectionAccount.vue'),
          meta: {
            title: '收款账户维护',
          },
        },
        {
          path: '/generalTransportPlan',
          name: 'generalTransportPlan',
          iframeComponent: () => import('../pages/coordination/generalTransportPlan.vue'),
          meta: {
            isIntercept: true,
            title: '运输计划维护',
          },
        },
        {
          path: '/generalTransportPlanSearch',
          name: 'generalTransportPlanSearch',
          iframeComponent: () => import('../pages/coordination/generalTransportPlanSearch.vue'),
          meta: {
            isIntercept: true,
            title: '运输计划查询',
          },
        },
        {
          path: '/coalBlendingList',
          name: 'coalBlendingList',
          iframeComponent: () => import('../pages/coordination/coalBlendingList.vue'),
          meta: {
            isIntercept: true,
            title: '配煤出库维护',
          },
        },
        {
          path: '/coalBlendingListSearch',
          name: 'coalBlendingListSearch',
          iframeComponent: () => import('../pages/coordination/coalBlendingListSearch.vue'),
          meta: {
            isIntercept: true,
            title: '配煤出库查询',
          },
        },
        {
          path: '/shipmentDisplayList',
          name: 'shipmentDisplayList',
          iframeComponent: () => import('../pages/coordination/shipmentDisplayList.vue'),
          meta: {
            isIntercept: true,
            title: '煤炭拣货维护',
          },
        },
        {
          path: '/blendingPlanMaintain',
          name: 'blendingPlanMaintain',
          iframeComponent: () => import('../pages/coordination/blendingPlanMaintain.vue'),
          meta: {
            isIntercept: true,
            title: '配煤方案维护',
          },
        },
        {
          path: '/blendingPlanSearch',
          name: 'blendingPlanSearch',
          iframeComponent: () => import('../pages/coordination/blendingPlanSearch.vue'),
          meta: {
            isIntercept: true,
            title: '配煤方案查询',
          },
        },
        {
          path: '/shipmentDisplaySearch',
          name: 'shipmentDisplaySearch',
          iframeComponent: () => import('../pages/coordination/shipmentDisplaySearch.vue'),
          meta: {
            isIntercept: true,
            title: '煤炭拣货查询',
          },
        },
        {
          path: '/distributionPlan',
          name: 'distributionPlan',
          iframeComponent: () => import('../pages/coordination/distributionPlan.vue'),
          meta: {
            isIntercept: true,
            title: '配送计划查询',
          },
        },
        {
          path: '/transportPlan',
          name: 'transportPlan',
          iframeComponent: () => import('../pages/coordination/transportPlan.vue'),
          meta: {
            isIntercept: true,
            title: '发货通知单',
          },
        },
        {
          path: '/checkOrderCreate',
          name: 'checkOrderCreate',
          iframeComponent: () => import('../pages/coordination/checkOrderCreate.vue'),
          meta: {
            isIntercept: true,
            title: '盘点单创建',
          },
        },
        {
          path: '/stockResult',
          name: 'stockResult',
          iframeComponent: () => import('../pages/coordination/stockResult.vue'),
          meta: {
            isIntercept: true,
            title: '盘点结果录入',
          },
        },
        {
          path: '/diffencePosting',
          name: 'diffencePosting',
          iframeComponent: () => import('../pages/coordination/diffencePosting.vue'),
          meta: {
            isIntercept: true,
            title: '盘点差异过账',
          },
        },
        {
          path: '/stockQuery',
          name: 'stockQuery',
          iframeComponent: () => import('../pages/coordination/stockQuery.vue'),
          meta: {
            isIntercept: true,
            title: '盘点单查询',
          },
        },
        {
          path: '/inventoryQuery',
          name: 'inventoryQuery',
          iframeComponent: () => import('../pages/coordination/inventoryQuery.vue'),
          meta: {
            isIntercept: true,
            title: '库存查询',
          },
        },
        {
          path: '/werksInspection',
          name: 'werksInspection',
          iframeComponent: () => import('../pages/coordination/werksInspection.vue'),
          meta: {
            isIntercept: true,
            title: '巡检信息录入',
          },
        },
        {
          path: '/werksInspectionSearch',
          name: 'werksInspectionSearch',
          iframeComponent: () => import('../pages/coordination/werksInspectionSearch.vue'),
          meta: {
            isIntercept: true,
            title: '巡检信息查询',
          },
        },
        {
          path: '/replenish',
          name: 'replenish',
          iframeComponent: () => import('../pages/coordination/replenish.vue'),
          meta: {
            isIntercept: true,
            title: '调进计划查询',
          },
        },
        {
          path: '/receiptRegistration',
          name: 'receiptRegistration',
          iframeComponent: () => import('../pages/coordination/receiptRegistration.vue'),
          meta: {
            isIntercept: true,
            title: '到货登记运输计划',
          },
        },
        {
          path: '/deliveryNote',
          name: 'deliveryNote',
          iframeComponent: () => import('../pages/coordination/deliveryNote.vue'),
          meta: {
            isIntercept: true,
            title: '到货登记发货单',
          },
        },
        {
          path: '/writeOff',
          name: 'writeOff',
          iframeComponent: () => import('../pages/coordination/writeOff.vue'),
          meta: {
            isIntercept: true,
            title: '入库实物冲销',
          },
        },
        {
          path: '/arrivalRecordQuery',
          name: 'arrivalRecordQuery',
          iframeComponent: () => import('../pages/coordination/arrivalRecordQuery.vue'),
          meta: {
            isIntercept: true,
            title: '到货记录查询',
          },
        },
        {
          path: '/outOfStockMgtSelfDelivery',
          name: 'outOfStockMgtSelfDelivery',
          iframeComponent: () => import('../pages/coordination/outOfStockMgtSelfDelivery.vue'),
          meta: {
            isIntercept: true,
            title: '物资出库',
          },
        },
        {
          path: '/outOfStockMgtChargeAgainst',
          name: 'outOfStockMgtChargeAgainst',
          iframeComponent: () => import('../pages/coordination/outOfStockMgtChargeAgainst.vue'),
          meta: {
            isIntercept: true,
            title: '出库记录冲销',
          },
        },
        {
          path: '/outOfStockRecordQuery',
          name: 'outOfStockRecordQuery',
          iframeComponent: () => import('../pages/coordination/outOfStockRecordQuery.vue'),
          meta: {
            isIntercept: true,
            title: '出库记录查询',
          },
        },
        {
          path: '/coallook',
          name: 'coallook',
          iframeComponent: () => import('../pages/coordination/coallook.vue'),
          meta: {
            isIntercept: true,
            title: '质检单查询',
          },
        },
        {
          path: '/coalsearchhx',
          name: 'coalsearchhx',
          iframeComponent: () => import('../pages/coordination/coalsearchhx.vue'),
          meta: {
            isIntercept: true,
            title: '质检单核销',
          },
        },
        {
          path: '/coalsearchzlwh',
          name: 'coalsearchzlwh',
          iframeComponent: () => import('../pages/coordination/coalsearchzlwh.vue'),
          meta: {
            isIntercept: true,
            title: '质检单资料维护',
          },
        },
        {
          path: '/coalNoticeSeach',
          name: 'coalNoticeSeach',
          iframeComponent: () => import('../pages/coordination/coalNoticeSeach.vue'),
          meta: {
            isIntercept: true,
            title: '质检通知单查询',
          },
        },
        {
          path: '/coalseach',
          name: 'coalseach',
          iframeComponent: () => import('../pages/coordination/coalseach.vue'),
          meta: {
            isIntercept: true,
            title: '质检结果录入',
          },
        },
        {
          path: '/coalqr',
          name: 'coalqr',
          iframeComponent: () => import('../pages/coordination/coalqr.vue'),
          meta: {
            isIntercept: true,
            title: '入库数量确认',
          },
        },
        {
          path: '/transportPlanMt',
          name: 'transportPlanMt',
          iframeComponent: () => import('../pages/coordination/transportPlanMt.vue'),
          meta: {
            isIntercept: true,
            title: '发货单',
          },
        },
        {
          path: '/invoiceSearch',
          name: 'invoiceSearch',
          iframeComponent: () => import('../pages/coordination/invoiceSearch.vue'),
          meta: {
            isIntercept: true,
            title: '发货单查询',
          },
        },
        {
          path: '/materialBatchConfig',
          name: 'materialBatchConfig',
          iframeComponent: () => import('../pages/coordination/materialBatchConfig.vue'),
          meta: {
            isIntercept: true,
            title: '物料与批次关系',
          },
        },
        {
          path: '/factoryWarehouseConfig',
          name: 'factoryWarehouseConfig',
          iframeComponent: () => import('../pages/coordination/factoryWarehouseConfig.vue'),
          meta: {
            isIntercept: true,
            title: '工厂与垛位关系',
          },
        },
        {
          path: '/invoiceRevoke',
          name: 'invoiceRevoke',
          iframeComponent: () => import('../pages/coordination/invoiceRevoke.vue'),
          meta: {
            isIntercept: true,
            title: '发货单撤销',
          },
        },
        {
          path: '/invoiceQualityControl',
          name: 'invoiceQualityControl',
          iframeComponent: () => import('../pages/coordination/invoiceQualityControl.vue'),
          meta: {
            isIntercept: true,
            title: '发运质检结果补录',
          },
        },
        {
          path: '/shipmentDisplayHX',
          name: 'shipmentDisplayHX',
          iframeComponent: () => import('../pages/coordination/shipmentDisplayHX.vue'),
          meta: {
            isIntercept: true,
            title: '煤炭拣货核销',
          },
        },
        {
          path: '/baseStock',
          name: 'baseStock',
          iframeComponent: () => import('../pages/coordination/statement.vue'),
          meta: {
            isIntercept: true,
            title: '基地库存管理',
          },
        },
        {
          path: '/statementDelivery',
          name: 'statementDelivery',
          iframeComponent: () => import('../pages/coordination/statement.vue'),
          meta: {
            isIntercept: true,
            title: '物流基地配送情况',
          },
        },
        {
          path: '/statementTransfer',
          name: 'statementTransfer',
          iframeComponent: () => import('../pages/coordination/statement.vue'),
          meta: {
            isIntercept: true,
            title: '陆运调进明细',
          },
        },
        {
          path: '/statementTransferDetails',
          name: 'statementTransferDetails',
          iframeComponent: () => import('../pages/coordination/statement.vue'),
          meta: {
            isIntercept: true,
            title: '水运调进明细',
          },
        },
        {
          path: '/statementDeliveryDetails',
          name: 'statementDeliveryDetails',
          iframeComponent: () => import('../pages/coordination/statement.vue'),
          meta: {
            isIntercept: true,
            title: '基地月度配送明细',
          },
        },
        {
          path: '/statementYearTransferDetails',
          name: 'statementYearTransferDetails',
          iframeComponent: () => import('../pages/coordination/statement.vue'),
          meta: {
            isIntercept: true,
            title: '基地年度调进明细',
          },
        },
        {
          path: '/statementYearDeliveryDetails',
          name: 'statementYearDeliveryDetails',
          iframeComponent: () => import('../pages/coordination/statement.vue'),
          meta: {
            isIntercept: true,
            title: '基地年度配送明细',
          },
        },
        {
          path: '/trilateralCooperate',
          name: 'trilateralCooperate',
          iframeComponent: () => import('../pages/coordination/trilateralCooperate.vue'),
          meta: {
            isIntercept: true,
            title: '销售信息确认',
          },
        },
        {
          path: '/hazardInformation',
          name: 'hazardInformation',
          iframeComponent: () => import('../pages/coordination/dangerousChemicals.vue'),
          meta: {
            isIntercept: true,
            title: '危害信息维护',
          },
        },
        {
          path: '/hazardInformationQuery',
          name: 'hazardInformationQuery',
          iframeComponent: () => import('../pages/coordination/dangerousChemicals.vue'),
          meta: {
            isIntercept: true,
            title: '危害信息查询',
          },
        },
        {
          path: '/hazardInformationBg',
          name: 'hazardInformationBg',
          iframeComponent: () => import('../pages/coordination/dangerousChemicals.vue'),
          meta: {
            isIntercept: true,
            title: '危害信息变更',
          },
        },
        {
          path: '/hazardInfoChangeQuery',
          name: 'hazardInfoChangeQuery',
          iframeComponent: () => import('../pages/coordination/dangerousChemicals.vue'),
          meta: {
            isIntercept: true,
            title: '危害信息变更查询',
          },
        },
        {
          path: '/myDeliveryNote',
          name: 'myDeliveryNote',
          iframeComponent: () => import('../pages/coordination/deliveryCollaboration.vue'),
          meta: {
            isIntercept: true,
            title: '我的发货单',
          },
        },
        {
          path: '/myDeliveryNotification',
          name: 'myDeliveryNotification',
          iframeComponent: () => import('../pages/coordination/deliveryCollaboration.vue'),
          meta: {
            isIntercept: true,
            title: '我的发货通知单',
          },
        },
        {
          path: '/shippingOrderQuery',
          name: 'shippingOrderQuery',
          iframeComponent: () => import('../pages/coordination/deliveryCollaboration.vue'),
          meta: {
            isIntercept: true,
            title: '发货单查询',
          },
        },
        {
          path: '/transferCreate',
          name: 'transferCreate',
          iframeComponent: () => import('../pages/coordination/transferCreate.vue'),
          meta: {
            isIntercept: true,
            title: '转储单创建',
          },
        },
        {
          path: '/transferManageEdit',
          name: 'transferManageEdit',
          iframeComponent: () => import('../pages/coordination/transferManageEdit.vue'),
          meta: {
            isIntercept: true,
            title: '转储单编辑',
          },
        },
        {
          path: '/transferQuery',
          name: 'transferQuery',
          iframeComponent: () => import('../pages/coordination/transferQuery.vue'),
          meta: {
            isIntercept: true,
            title: '转储单查询',
          },
        },
        {
          path: '/transferPosting',
          name: 'transferPosting',
          iframeComponent: () => import('../pages/coordination/transferPosting.vue'),
          meta: {
            isIntercept: true,
            title: '转储单冲销',
          },
        },
        {
          path: '/tieredPrice',
          name: 'TieredPrice',
          component: () => import('../pages/tiered-price/tieredPrice.vue'),
          meta: {
            title: '价格管理',
          },
        },
        {
          path: '/valveDataImport',
          name: 'valveDataImport',
          component: () => import('../pages/valveDataImport/Index.vue'),
          meta: { title: '供应服务能力' },
        },
        {
          path: '/businessInvoice',
          name: 'businessInvoice',
          component: () => import('../pages/nesting/businessInvoice.vue'),
          meta: { title: '发票管理' },
        },
        // 20220831合并到设置—>交易参数设置
        // {
        //   path: "/purchaseProductRangeSet",
        //   name: "purchaseProductRangeSet",
        //   iframeComponent: () => import("../pages/company/purchaseProductRangeSet.vue"),
        //   meta: {title: "采购商品范围设置"}
        // },
        {
          path: '/sharedResourceAgreementManage',
          name: 'sharedResourceAgreementManage',
          component: () => import('../pages/agreement/sharedResourceAgreementManage.vue'),
          meta: { title: '共享资源协议管理' },
        },
        {
          path: '/sharedResourceGoodsMaintenance',
          name: 'sharedResourceGoodsMaintenance',
          iframeComponent: () => import('../pages/agreement/sharedResourceGoodsMaintenance.vue'),
          meta: { title: '共享资源维护商品' },
        },
        {
          path: '/sharedResourceAgreementDetail',
          name: 'sharedResourceAgreementDetail',
          component: () => import('../pages/agreement/sharedResourceAgreementDetail.vue'),
          meta: { title: '共享资源协议详情' },
        },
        {
          path: '/shareAgreementEdit',
          name: 'shareAgreementEdit',
          iframeComponent: () => import('../pages/agreement/shareAgreementEdit.vue'),
          meta: { title: '共享资源协议编辑2' },
        },
        {
          path: '/flowDirectionList',
          name: 'flowDirectionList',
          iframeComponent: () => import('../pages/flowDirection/flowDirectionList.vue'),
          meta: { title: '发货单流向列表' },
        },
        {
          path: '/flowDirectionDetail',
          name: 'flowDirectionDetail',
          iframeComponent: () => import('../pages/flowDirection/flowDirectionDetail.vue'),
          meta: { title: '流向列表详情' },
        },
        {
          path: '/createApprove',
          name: 'createApprove',
          iframeComponent: () => import('../pages/approve/component/createApprove'),
          meta: { title: '审批流配置' },
        },
        {
          path: '/editPurchaseApprove',
          name: 'editPurchaseApprove',
          iframeComponent: () => import('../pages/approve/component/editApprove'),
          meta: { title: '修改采购计划审批' },
        },
        {
          path: '/approveSetting',
          name: 'approveSetting',
          iframeComponent: () => import('../pages/approve/index.vue'),
          meta: { title: '采购审批设置' },
        },
        // {
        //   path: "/orderApprove",
        //   name: "orderApprove",
        //   iframeComponent: () => import("../pages/approve/orderApprove/index.vue"),
        //   meta: {title: "提交订单审批"}
        // },
        {
          path: '/requirementApprove',
          name: 'requirementApprove',
          iframeComponent: () => import('../pages/approve/requirement/index.vue'),
          meta: { title: '需求管理审批' },
        },
        {
          path: '/purchaseApprove',
          name: 'purchaseApprove',
          iframeComponent: () => import('../pages/approve/purchaseApprove/index.vue'),
          meta: { title: '采购计划审批' },
        },
        {
          path: '/approve/announcement',
          name: 'ApproveAnnouncement',
          iframeComponent: () => import('../pages/approve/announcement/index.vue'),
          meta: { title: '公告审批' },
        },
        {
          path: '/enquireApprove',
          name: 'enquireApprove',
          iframeComponent: () => import('../pages/approve/enquireApprove/index.vue'),
          meta: { title: '询比价审批' },
        },
        {
          path: '/vendorPricing',
          name: 'vendorPricing',
          iframeComponent: () => import('../pages/approve/vendorPricing/index.vue'),
          meta: { title: '询比价选商定价审批' },
        },
        {
          path: '/supplierManagement',
          name: 'supplierManagement',
          component: () => import('../pages/supplierManagement/index.vue'),
          meta: { title: '供应商资源' },
        },
        {
          path: '/supplierDetail',
          name: 'supplierDetail',
          component: () => import('../pages/supplierManagement/supplierDetail.vue'),
          meta: { title: '供应商详情' },
        },
        {
          path: '/orderApproveCreate',
          name: 'orderApproveCreate',
          component: () => import('../pages/approve/component/orderApproveCreate'),
          meta: { title: '新增审核' },
        },
        {
          path: '/orderApproveEdit',
          name: 'orderApproveEdit',
          component: () => import('../pages/approve/component/orderApproveEdit'),
          meta: { title: '编辑审核' },
        },
        {
          path: '/orderApprove',
          name: 'orderApprove',
          component: () => import('../pages/approve/component/orderApproveList'),
          meta: { title: '订单审批' },
        },
        {
          path: '/dataStatistics',
          name: 'dataStatistics',
          component: () => import('../pages/dataStatistics/marketData'),
          meta: { title: '销售数据统计' },
        },
        {
          path: '/reconciliationManage',
          name: 'reconciliationManage',
          component: () => import('../pages/reconciliationManage'),
          meta: {
            title: '对账管理',
          },
        },
        {
          path: '/noticeOfCharge',
          name: 'noticeOfCharge',
          component: () => import('../pages/noticeOfCharge'),
          meta: {
            title: '收费通知书管理',
          },
        },
        {
          path: '/noticeOfChargeDetails',
          name: 'noticeOfChargeDetails',
          component: () => import('../pages/noticeOfCharge/details'),
          meta: {
            title: '收费通知书详情',
          },
        },
        {
          path: '/statementDetails',
          name: 'statementDetails',
          component: () => import('../pages/reconciliationManage/statementDetails'),
          meta: {
            title: '对账单详情',
          },
        },
        {
          path: '/withdrawRecord',
          name: 'statementDetails',
          component: () => import('../pages/account/withdrawRecord'),
          meta: {
            title: '提现记录',
          },
        },
        {
          path: '/transactionRecord',
          name: 'transactionRecord',
          component: () => import('../pages/account/transactionRecord'),
          meta: {
            title: '交易记录查询',
          },
        },
        {
          path: '/bankCardManagement',
          name: 'bankCardManagement',
          component: () => import('../pages/pay/bankCardManagement'),
          meta: {
            title: '银行卡管理',
          },
        },
        {
          path: '/cpcnAccount',
          name: 'cpcnAccount',
          component: () => import('../pages/chinaPayment/accountMgt'),
          meta: {
            title: '中金账号管理',
          },
        },
        {
          path: '/accountManagement',
          name: 'accountManagement',
          component: () => import('../pages/pay/accountManagement'),
          meta: {
            title: '账户信息设置',
          },
        },
        {
          path: '/emergency',
          meta: {
            title: '易应急专区设置',
          },
          component: () => import('../pages/emergency/index'),
        },
        {
          path: '/storeInfo',
          name: 'storeInfo',
          component: () => import('../pages/product/storeInfo/storeInfo.vue'),
          meta: {
            title: '储备专区商品查询',
          },
        },
        {
          path: '/openingCollection',
          name: 'openingCollection',
          component: () => import('../pages/scanCodePayManagement/openingCollection'),
          meta: {
            title: '开通收款',
          },
        },
        {
          path: '/scanCodePayManagement',
          name: 'scanCodePayManagement',
          component: () => import('../pages/scanCodePayManagement'),
          meta: {
            title: '扫码支付管理',
          },
        },

        {
          path: '/activityNotification',
          name: 'activityNotification',
          component: () => import('../pages/activityManagement/activityNotification'),
          meta: {
            title: '活动通知列表',
          },
        },
        {
          path: '/eventRegistration',
          name: 'eventRegistration',
          component: () => import('../pages/activityManagement/eventRegistration'),
          meta: {
            title: '活动报名',
          },
        },

        // 新增询比价管理 专采 -> ea
        {
          path: '/enquiryManage/enquiryIss',
          name: 'EnquiryIss',
          component: () => import('../pages/enquiryManage/enquiryIss'),
          meta: {
            title: '发布询价单',
          },
        },
        {
          path: '/enquiryManage/enquiry/enquiryRevealPricing',
          name: 'EnquiryRevealPricing',
          component: () => import('../pages/enquiryManage/enquiry/enquiryRevealPricing.vue'),
          meta: {
            title: '揭示',
          },
        },
        //

        {
          path: '/enquiryManage/enquirySuccess',
          name: 'EnquirySuccess',
          component: () => import('../pages/enquiryManage/enquirySuccess'),
          meta: {
            title: '发布成功',
          },
        },
        {
          path: '/enquiryManage/enquiry',
          name: 'EnquiryIss',
          component: () => import('../pages/enquiryManage/enquiry'),
          meta: {
            title: '询价单管理',
          },
        },
        {
          path: '/enquiryManage/enquiry/chooseBusinessPrice',
          name: 'ChooseBusinessPrice',
          component: () => import('../pages/enquiryManage/enquiry/chooseBusinessPrice'),
          meta: {
            title: '选商定价',
          },
        },
        {
          path: '/enquiryManage/enquiry/enquiryDetail',
          name: 'EnquiryDetail',
          component: () => import('../pages/enquiryManage/enquiry/enquiryDetail'),
          meta: {
            title: '询比价详情',
          },
        },
        {
          path: '/enquiryManage/enquiry/historyContrast',
          name: 'HistoryContrast',
          component: () => import('../pages/enquiryManage/enquiry/historyContrast'),
          meta: {
            title: '历史报价',
          },
        },
        {
          path: '/enquiryManage/enquiry/negotiationRemark',
          name: 'NegotiationRemark',
          component: () => import('../pages/enquiryManage/enquiry/negotiationRemark'),
          meta: {
            title: '磋商记录',
          },
        },
        {
          path: '/enquiryManage/enquiry/releaseEnquiry',
          name: 'ReleaseEnquiry',
          component: () => import('../pages/enquiryManage/enquiry/releaseEnquiry'),
          meta: {
            title: '询价单编辑',
          },
        },
        {
          path: '/enquiryManage/enquirySuccess',
          name: 'ReleaseEnquiry',
          component: () => import('../pages/enquiryManage/enquirySuccess'),
          meta: {
            title: '询价成功',
          },
        },
        // 需求
        {
          path: '/demand/demandManage',
          name: 'DemandManage',
          component: () => import('../pages/demand/demandManage'),
          meta: {
            title: '需求计划提报',
          },
        },
        {
          path: '/demand/demandManage/createDemand',
          name: 'CreateDemand',
          component: () => import('../pages/demand/demandManage/createDemand.vue'),
          meta: {
            title: '创建需求',
          },
        },
        {
          path: '/demand/demandManage/demandDetail',
          name: 'DemandDetail',
          component: () => import('../pages/demand/demandManage/demandDetail'),
          meta: {
            title: '需求详情',
          },
        },
        {
          path: '/demand/execute',
          name: 'Execute',
          component: () => import('../pages/demand/execute'),
          meta: {
            title: '需求计划执行',
          },
        },
        {
          path: '/demand/execute/agreementDetail',
          name: 'AgreementDetail',
          component: () => import('../pages/demand/execute/agreementDetail'),
          meta: {
            title: '采购协议详情',
          },
        },
        {
          path: '/demand/execute/choose',
          name: 'Choose',
          component: () => import('../pages/demand/execute/chooseCopy'),
          meta: {
            title: '选品下单',
          },
        },
        {
          path: '/demand/execute/requestOrder',
          name: 'RequestOrder',
          component: () => import('../pages/demand/execute/requestOrder'),
          meta: {
            title: '执行框架协议',
          },
        },
        {
          path: '/demand/execute/selectGoods',
          name: 'SelectGoods',
          component: () => import('../pages/demand/execute/selectGoods'),
          meta: {
            title: '选择商品',
          },
        },
        {
          path: '/demand/track',
          name: 'Track',
          component: () => import('../pages/demand/track'),
          meta: {
            title: '需求计划跟踪',
          },
        },
        {
          path: '/plan/purchaseWayEdit',
          name: 'PurchaseWayEdit',
          component: () => import('../pages/plan/purchaseWayEdit'),
          meta: {
            title: '采购计划编制',
          },
        },
        {
          path: '/plan/purchaseWayEdit/handCreated',
          name: 'HandCreated',
          component: () => import('../pages/plan/purchaseWayEdit/handCreated'),
          meta: {
            title: '采购编制',
          },
        },
        {
          path: '/plan/purchaseWayEdit/agreementDetail',
          name: 'AgreementDetail',
          component: () => import('../pages/plan/purchaseWayEdit/agreementDetail'),
          meta: {
            title: '采购编制',
          },
        },
        {
          path: '/plan/purchaseQuery',
          name: 'PurchaseQuery',
          component: () => import('../pages/plan/purchaseQuery'),
          meta: {
            title: '采购执行',
          },
        },
        {
          path: '/plan/purchaseQuery/purchaseDetail',
          name: 'PurchaseDetail',
          component: () => import('../pages/plan/purchaseQuery/purchaseDetail'),
          meta: {
            title: '采购执行详情',
          },
        },
        {
          path: '/plan/purchaseWayExecute',
          name: 'PurchaseWayExecute',
          component: () => import('../pages/plan/purchaseWayExecute'),
          meta: {
            title: '采购计划执行',
          },
        },
        {
          path: '/plan/purchaseWayExecute',
          name: 'PurchaseWayExecute',
          component: () => import('../pages/plan/purchaseWayExecute'),
          meta: {
            title: '采购计划执行',
          },
        },
        {
          path: '/plan/purchaseWayExecute/choose',
          name: 'WayChoose',
          component: () => import('../pages/plan/purchaseWayExecute/choose'),
          meta: {
            title: '采购计划执行',
          },
        },
        {
          path: '/plan/purchaseWayExecute/selectGoods',
          name: 'WaySelectGoods',
          component: () => import('../pages/plan/purchaseWayExecute/selectGoods'),
          meta: {
            title: '采购计划执行',
          },
        },
        {
          path: '/plan/purchaseWayAfter',
          name: 'PurchaseWayAfter',
          component: () => import('../pages/plan/purchaseWayAfter'),
          meta: {
            title: '采购计划跟踪',
          },
        },
        {
          path: '/auditManagement/demand',
          name: 'auditDemand',
          component: () => import('../pages/auditManagement/demand'),
          meta: {
            title: '需求计划审批',
          },
        },
        {
          path: '/auditManagement/demand/demandDetail',
          name: 'auditDemandDetail',
          component: () => import('../pages/auditManagement/demand/demandDetail'),
          meta: {
            title: '需求审核详情',
          },
        },
        {
          path: '/auditManagement/enquiry',
          name: 'auditEnquiry',
          component: () => import('../pages/auditManagement/enquiry'),
          meta: {
            title: '询比价审批',
          },
        },
        {
          path: '/auditManagement/enquiry/enquiryDetail',
          name: 'auditDemandDetail',
          component: () => import('../pages/auditManagement/enquiry/enquiryDetail'),
          meta: {
            title: '询比价审核详情',
          },
        },
        {
          path: '/auditManagement/procurementPlan',
          name: 'auditProcurementPlan',
          component: () => import('../pages/auditManagement/procurementPlan'),
          meta: {
            title: '采购计划审批',
          },
        },
        {
          path: '/auditManagement/procurementPlan/procurementPlanDetail',
          name: 'ProcurementPlanDetail',
          component: () => import('../pages/auditManagement/procurementPlan/procurementPlanDetail.vue'),
          meta: {
            title: '计划审核详情',
          },
        },
        {
          path: '/auditManagement/orderAudit/allOrder',
          name: 'AuditAllOrder',
          component: () => import('../pages/auditManagement/orderAudit/allOrder.vue'),
          meta: {
            title: '计划审核详情',
          },
        },
        {
          path: '/auditManagement/orderAudit',
          name: 'AuditOrderAudit',
          component: () => import('../pages/auditManagement/orderAudit'),
          meta: {
            title: '订单审批',
          },
        },
        {
          path: '/auditManagement/orderAudit/orderDetail',
          name: 'AuditOrderDetail',
          component: () => import('../pages/auditManagement/orderAudit/orderDetail'),
          meta: {
            title: '计划审核详情',
          },
        },
        {
          path: '/auditManagement/announcement',
          name: 'AuditManagementAnnouncement',
          component: () => import('../pages/auditManagement/announcement/index.vue'),
          meta: { title: '公告审批列表' },
        },

        {
          path: '/auditManagement/announcementAudit',
          name: 'AnnouncementAudit',
          component: () => import('../pages/auditManagement/announcement/announcementAudit.vue'),
          meta: { title: '公告审批' },
        },

        {
          path: '/auditManagement/announcementDetail',
          name: 'AnnouncementDetail',
          component: () => import('../pages/auditManagement/announcement/announcementDetail.vue'),
          meta: { title: '公告审批详情' },
        },

        // 工作台
        /* {
          path: '/workbench',
          name: 'Workbench',
          component: () => import('../pages/workbench'),
          meta: {
            title: '采购工作台',
          },
        }, */
        // 体化采购申请
        {
          path: '/myPurchaseRequest',
          name: 'MyPurchaseRequest',
          component: () => import('../pages/myPurchaseRequest/index.vue'),
          meta: {
            title: '一体化采购申请',
          },
        },
        {
          path: '/myPurchaseRequest/checked',
          name: 'MyPurchaseRequestChecked',
          component: () => import('../pages/myPurchaseRequest/checked.vue'),
          meta: {
            title: '一体化采购申请',
          },
        },
        // 体化采购申请跟踪
        {
          path: '/purchaseApplyTrack',
          name: 'PurchaseApplyTrack',
          component: () => import('../pages/purchaseApplyTrack'),
          meta: {
            title: '一体化采购申请跟踪',
          },
        },
        {
          path: '/fusePurchaseRequest',
          name: 'FusePurchaseRequest',
          component: () => import('../pages/fusePurchaseRequest'),
          meta: {
            title: '融合方案采购申请',
          },
        },
        {
          path: '/fusePurchaseRequest/fuseChooseGoods',
          name: 'FuseChooseGoods',
          component: () => import('../pages/fusePurchaseRequest/fuseChooseGoods'),
          meta: {
            title: '融合方案采购申请',
          },
        },
        {
          path: '/enterpriseCategory',
          name: 'enterpriseCategory',
          component: () => import('../pages/enterpriseCategory'),
          meta: {
            title: '企业类目映射',
          },
        },
        {
          path: '/ES/ESapply',
          name: 'ESapply',
          component: () => import('../pages/ES/ESapply/index'),
          meta: {
            title: '我的评价申请',
          },
        },
        {
          path: '/ES/ESapply/editProductEvaluation',
          name: 'editProductEvaluation',
          component: () => import('../pages/ES/ESapply/editProductEvaluation.vue'),
          meta: {
            title: '我的产品评价',
          },
        },

        {
          path: '/ES/ESorganization',
          name: 'ESorganization',
          component: () => import('../pages/ES/ESorganization/index'),
          meta: {
            title: '产品质量评价',
          },
        },
        // ESorganizationEdit
        {
          path: '/ES/ESorganization/ESorganizationEdit',
          name: 'ESorganizationEdit',
          component: () => import('../pages/ES/ESorganization/ESorganizationEdit.vue'),
          meta: {
            title: '产品质量评价编辑',
          },
        },
        {
          path: '/ES/ESorganization/ESorganizationDetail',
          name: 'ESorganizationDetail',
          component: () => import('../pages/ES/ESorganization/ESorganizationDetail.vue'),
          meta: {
            title: '产品质量评价详情',
          },
        },
        {
          path: '/applicationEvaluation',
          name: 'applicationEvaluation',
          component: () => import('../pages/applicationEvaluation/index.vue'),
          meta: {
            title: '申请评价办法',
          },
        },
        {
          path: '/ES/ESapply/productEvaluationInfo',
          name: 'productEvaluationInfo',
          component: () => import('../pages/ES/ESapply/productEvaluationInfo.vue'),
          meta: {
            title: '我的产品评价详情',
          },
        },
        {
          path: '/ES/ESapply/ESorganizationPayment',
          name: 'ESorganizationPayment',
          component: () => import('../pages/ES/ESapply/ESorganizationPayment.vue'),
          meta: {
            title: '付款申请单',
          },
        },

        {
          path: '/ES/unstructured',
          name: 'productUnstructured',
          component: () => import('../pages/ES/unstructured/index.vue'),
          meta: {
            title: '非结构化（暂）',
          },
        },
        {
          path: 'ES/applyConfirm',
          name: 'applyConfirm',
          component: () => import('../pages/ES/applyConfirm/index.vue'),
          meta: {
            title: '评价申请确认',
          },
        },
        {
          path: 'ES/applyConfirm/applyConfirmAudit',
          name: 'applyConfirmAudit',
          component: () => import('../pages/ES/applyConfirm/applyConfirmAudit.vue'),
          meta: {
            title: '评价申请审批',
          },
        },
        {
          path: '/ES/ESapply/uploadProductEvaluation',
          name: 'uploadProductEvaluation',
          component: () => import('../pages/ES/ESapply/uploadProductEvaluation.vue'),
          meta: {
            title: '我的产品评价',
          },
        },
        {
          path: '/ES/enterpriseInfoReview',
          name: 'enterpriseInfoReview',
          component: () => import('../pages/ES/enterpriseInfoReview'),
          meta: {
            title: '企业信息审核',
          },
        },
        {
          path: '/ES/enterpriseInfoReview/details',
          name: 'enterpriseInfoReviewDetails',
          component: () => import('../pages/ES/enterpriseInfoReview/details'),
          meta: {
            title: '企业信息详情',
          },
        },
        {
          path: '/ES/enterpriseInfoReview/review',
          name: 'enterpriseInfoReviewReview',
          component: () => import('../pages/ES/enterpriseInfoReview/review'),
          meta: {
            title: '审核企业信息',
          },
        },
        {
          path: '/ES/orderQuery',
          name: 'orderQuery',
          component: () => import('../pages/ES/orderQuery'),
          meta: {
            title: '订单查询',
          },
        },
        {
          path: '/ES/orderQuery/details',
          name: 'esOrderDetails',
          component: () => import('../pages/ES/orderQuery/details'),
          meta: {
            title: '订单详情',
          },
        },
        {
          path: '/ES/reportReview',
          name: 'reportReview',
          component: () => import('../pages/ES/reportReview'),
          meta: {
            title: '报告审核',
          },
        },
        {
          path: '/ES/reportReview/details',
          name: 'esReportReviewDetails',
          component: () => import('../pages/ES/reportReview/details'),
          meta: {
            title: '报告审核详情',
          },
        },
        {
          path: '/ES/businessManagement',
          name: 'businessManagement',
          component: () => import('../pages/ES/businessManagement'),
          meta: {
            title: '评价业务管理',
          },
        },
        {
          path: '/ES/businessManagement/details',
          name: 'businessManagementDetails',
          component: () => import('../pages/ES/businessManagement/details'),
          meta: {
            title: '评价业务管理详情',
          },
        },
        {
          path: '/ES/businessManagement/enter',
          name: 'businessManagementEnter',
          component: () => import('../pages/ES/businessManagement/enter'),
          meta: {
            title: '评价业务管理录入',
          },
        },
        {
          path: '/ES/reviewNotification',
          name: 'reviewNotification',
          meta: { title: '我的评价通知' },
          component: () => import('../pages/ES/reviewNotification/index'),
        },
        {
          path: '/ES/enterpriseInfoReview/commissionSheet',
          name: 'commissionSheet',
          meta: {
            title: '评价委托书',
          },
          component: () => import('../pages/ES/enterpriseInfoReview/commissionSheet'),
        },
        {
          path: '/ES/reviewNotification/evaluationNotice',
          name: 'evaluationNotice',
          meta: {
            title: '评价通知书',
          },
          component: () => import('../pages/ES/reviewNotification/evaluationNotice'),
        },

        {
          path: '/ES/viewReport',
          name: 'viewReport',
          meta: {
            title: '产品质量评价证书',
          },
          component: () => import('../pages/ES/reportReview/viewReport'),
        },
        {
          path: '/repaymentAccountMgt',
          name: 'repaymentAccountMgt',
          meta: {
            title: '产融还款专户管理',
          },
          component: () => import('../pages/repaymentAccountMgt/index'),
        },
        {
          path: '/repaymentApplyActivation',
          name: 'repaymentApplyActivation',
          meta: {
            title: '产融还款专户申请开通',
          },
          component: () => import('../pages/repaymentAccountMgt/repaymentApplyActivation'),
        },
        {
          path: '/logisticsProviderManagement',
          name: 'logisticsProviderManagement',
          meta: {
            title: '物流商管理',
          },
          component: () => import('../pages/materialFlow/logisticsProvider'),
        },
        {
          path: '/shipmentManagement',
          name: 'shipmentManagement',
          meta: {
            title: '发货地址管理',
          },
          component: () => import('../pages/materialFlow/repaymentApplyActivation'),
        },
        {
          path: '/electronicInvoice/invoiceService',
          component: () => import('../pages/electronicInvoice/invoiceServe/invoiceServe.vue'),
          meta: {
            title: '电子发票服务',
          },
        },
        {
          path: '/electronicInvoice/invoiceForm',
          component: () => import('../pages/electronicInvoice/invoiceForm/invoiceForm.vue'),
          meta: {
            title: '开票详情',
          },
        },

        {
          path: '/address',
          component: () => import('../pages/address'),
          meta: {
            title: '发货地址管理',
          },
        },
        {
          path: '/paymentAccount',
          name: 'PaymentAccount',
          meta: {
            title: '支付账户页',
          },
          component: () => import('../pages/paymentAccount/index.vue'),
        },
        {
          path: '/paymentAccountAddUser',
          name: 'PaymentAccountAddUser',
          meta: {
            title: '新增用户',
          },
          component: () => import('../pages/paymentAccount/paymentAccountUser/addUser'),
        },
        {
          path: '/paymentAccountUpdateUser',
          name: 'PaymentAccountUpdateUser',
          meta: {
            title: '修改用户',
          },
          component: () => import('../pages/paymentAccount/paymentAccountUser/updateUser'),
        },
        {
          path: '/paymentAccountAddUkey',
          name: 'PaymentAccountAddUkey',
          meta: {
            title: '补办Ukey',
          },
          component: () => import('../pages/paymentAccount/paymentAccountUser/addUkey'),
        },
        {
          path: '/paymentAccountLogoutUser',
          name: 'PaymentAccountLogoutUser',
          meta: {
            title: '注销用户',
          },
          component: () => import('../pages/paymentAccount/paymentAccountUser/logoutUser'),
        },
        {
          path: '/paymentAccountLogoutAccountSub',
          name: 'PaymentAccountLogoutAccountSub',
          meta: {
            title: '注销专户',
          },
          component: () => import('../pages/paymentAccount/paymentAccountUser/logoutAccount'),
        },
        {
          path: '/paymentAccountLogoutAccount',
          name: 'PaymentAccountLogoutAccount',
          meta: {
            title: '注销企业账户',
          },
          component: () => import('../pages/paymentAccount/paymentAccountUser/logoutAccount'),
        },
        {
          path: '/financialAccountOpening',
          name: 'financialAccountOpening',
          meta: {
            title: '产融还款专户申请开通',
          },
          component: () => import('../pages/paymentAccount/financialAccountOpening/financialAccountOpening'),
        },
        {
          path: '/filing/query',
          component: () => import('../pages/filing/query'),
          meta: {
            title: '备案查询',
          },
        },
        {
          path: '/distributeProfits',
          component: () => import('../pages/filing/distributeProfits'),
          meta: {
            title: '分润管理',
          },
        },
        {
          path: '/maintenanceContact',
          component: () => import('../pages/maintenanceContact/maintenanceContact'),
          meta: {
            title: '联系人',
          },
        },
        {
          path: '/roleApply',
          component: () => import('../pages/roleApply'),
          meta: {
            title: '角色申请',
          },
        },
        {
          path: '/roleApplyRecord',
          component: () => import('../pages/roleApply/roleApplyRecord'),
          meta: {
            title: '申请记录查看',
          },
        },
        {
          path: '/roleApplyCheck',
          component: () => import('../pages/roleApply/roleApplyCheck'),
          meta: {
            title: '权限申请审核',
          },
        },
        {
          path: '/roleApplyCheckRecord',
          component: () => import('../pages/roleApply/roleApplyCheckRecord'),
          meta: {
            title: '审核记录查看',
          },
        },
        {
          path: '/purchaseFrameAgreement',
          component: () => import('../pages/purchaseFrameAgreement/index'),
          meta: {
            title: '采购框架协议',
          },
        },
        {
          path: '/customizedManagement',
          component: () => import('../pages/customizedManagement/index'),
          meta: {
            title: '定制管理',
          },
        },
        {
          path: '/customizedDetail',
          component: () => import('../pages/customizedManagement/customizedDetail'),
          meta: {
            title: '定制详情',
          },
        },
        {
          path: '/waitInvoicesList',
          component: () => import('../pages/zhongJinPaymentManagement/waitInvoicesList'),
          meta: {
            title: '待开票清单',
          },
        },
        {
          path: '/invoiceRecords',
          component: () => import('../pages/zhongJinPaymentManagement/invoiceRecords'),
          meta: {
            title: '开票记录',
          },
        },
        {
          path: '/orderReport',
          component: () => import('../pages/orderReport'),
          meta: {
            title: '订单报表',
          },
        },
        {
          path: '/enquiryReport',
          component: () => import('../pages/enquiryReport'),
          meta: {
            title: '询比价报表',
          },
        },
        {
          path: '/otherMaintenance',
          component: () => import('../pages/ES/otherMaintenance'),
          meta: {
            title: '其他产品质量评价维护',
          },
        },
        {
          path: '/emergencyEnquiry/enquiryIss',
          component: () => import('../pages/emergencyEnquiry/enquiryIss'),
          meta: {
            title: '发布应急物资询价',
          },
        },
        {
          path: '/emergencyEnquiry/enquiryManage',
          component: () => import('../pages/emergencyEnquiry/enquiryManage'),
          meta: {
            title: '应急需求清单',
          },
        },
        {
          path: '/emergencyEnquiry/enquirySuccess',
          component: () => import('../pages/emergencyEnquiry/enquirySuccess'),
          meta: {
            title: '应急询价成功',
          },
        },

        {
          path: '/emergencyEnquiry/enquiryManage/chooseBusinessPrice',
          name: 'ChooseBusinessPrice',
          component: () => import('../pages/emergencyEnquiry/enquiryManage/chooseBusinessPrice'),
          meta: {
            title: '应急选商定价',
          },
        },
        {
          path: '/emergencyEnquiry/enquiryManage/enquiryDetail',
          name: 'EnquiryDetail',
          component: () => import('../pages/emergencyEnquiry/enquiryManage/enquiryDetail'),
          meta: {
            title: '应急需求详情',
          },
        },
        {
          path: '/emergencyEnquiry/enquiryManage/historyContrast',
          name: 'HistoryContrast',
          component: () => import('../pages/emergencyEnquiry/enquiryManage/historyContrast'),
          meta: {
            title: '历史报价',
          },
        },
        {
          path: '/emergencyEnquiry/enquiryManage/negotiationRemark',
          name: 'NegotiationRemark',
          component: () => import('../pages/emergencyEnquiry/enquiryManage/negotiationRemark'),
          meta: {
            title: '磋商记录',
          },
        },
        {
          path: '/emergencyEnquiry/enquiryManage/releaseEnquiry',
          name: 'ReleaseEnquiry',
          component: () => import('../pages/emergencyEnquiry/enquiryManage/releaseEnquiry'),
          meta: {
            title: '询价单编辑',
          },
        },
        // 应急报价
        {
          path: '/emergencyDirectedInquiry',
          name: 'DirectedInquiry',
          component: () => import('../pages/emergencyEnquiryPrice/directedInquiry.vue'),
          meta: {
            title: '定向需求',
          },
        },
        {
          path: '/emergencyOpenInquiry',
          name: 'emergencyOpenInquiry',
          component: () => import('../pages/emergencyEnquiryPrice/openInquiry.vue'),
          meta: {
            title: '公开需求',
          },
        },
        // havePrice
        {
          path: '/emergencyHavePrice',
          name: 'emergencyHavePrice',
          component: () => import('../pages/emergencyEnquiryPrice/havePrice.vue'),
          meta: {
            title: '应急已报价',
          },
        },
        {
          path: '/emergencySeeDetails',
          name: 'emergencySeeDetails',
          component: () => import('../pages/emergencyEnquiryPrice/seeDetails.vue'),
          meta: {
            title: '应急报价详情',
          },
        },
        //
        {
          path: '/emergencyNegotiationRemark',
          name: 'emergencyNegotiationRemark',
          component: () => import('../pages/emergencyEnquiryPrice/negotiationRemark.vue'),
          meta: {
            title: '磋商详情',
          },
        },
        {
          path: '/procurementWorkload',
          name: 'procurementWorkload',
          meta: {
            title: '采购工作量',
          },
          component: () => import('../pages/procurementWorkload/index.vue'),
        },
        {
          path: '/SysConnect',
          name: 'SysConnect',
          meta: {
            title: '劳动防护检测系统',
          },
          component: () => import('../pages/SysConnect'),
        },
        {
          path: '/rawMaterialOrder/mallOrder',
          name: 'MallOrder',
          meta: {
            title: '石化商城订单',
          },
          component: () => import('../pages/rawMaterialOrder/mallOrder/index.vue'),
        },
        {
          path: '/rawMaterialOrder/purchasingPlan',
          name: 'PurchasingPlan',
          meta: {
            title: '石化采购意向单',
          },
          component: () => import('../pages/rawMaterialOrder/purchasingPlan/index.vue'),
        },
        {
          path: '/rawMaterialOrder/stockOrder',
          name: 'StockOrder',
          meta: {
            title: '原材料库存订单管理',
          },
          component: () => import('../pages/rawMaterialOrder/stockOrder/index.vue'),
        },
        {
          path: '/rawMaterialOrder/stockOrder/newStock',
          name: 'NewStock',
          meta: {
            title: '原材料库存订单新增',
          },
          component: () => import('../pages/rawMaterialOrder/stockOrder/newStock.vue'),
        },
        {
          path: '/rawMaterialOrder/stockOrder/stockDetail/:id',
          name: 'StockDetail',
          meta: {
            title: '原材料库存订单详情',
          },
          component: () => import('../pages/rawMaterialOrder/stockOrder/stockDetail.vue'),
        },
        {
          path: '/rawMaterialDetail',
          name: 'rawMaterialDetail',
          meta: {
            title: '原材料详情',
          },
          component: () => import('../pages/rawMaterialOrder/rawMaterialDetail.vue'),
        },

        {
          path: '/groupStructureCompany',
          name: 'groupStructureCompany',
          meta: {
            title: '采购份额设置',
          },
          component: () => import('../pages/groupStructureCompany'),
        },
        {
          path: '/announcementManage/announcement',
          name: 'Announcement',
          meta: {
            title: '公告管理',
          },
          component: () => import('../pages/announcementManage/announcement/index.vue'),
        },
        {
          path: '/supplierListMaintenance',
          name: 'supplierListMaintenance',
          meta: {
            title: '供应商维护',
          },
          component: () => import('../pages/supplierListMaintenance/index.vue'),
        },

        {
          path: '/CarbonfootprintManage/Carbonfootprint',
          name: 'Carbonfootprint',
          meta: {
            title: '数据收集',
          },
          component: () => import('../pages/CarbonfootprintManage/index.vue'),
        },
        {
          path: '/CarbonfootprintManage/CarbonfootprintDetail',
          name: 'routert',
          meta: {
            title: '数据收集详情',
          },
          component: () => import('../pages/CarbonfootprintManage/CarbonfootprintDetail.vue'),
        },
        {
          path: '/enquiryInvoice',
          name: 'EnquiryInvoice',
          meta: {
            title: '易物流',
          },
          component: () => import('../pages/enquiryInvoice/index.vue'),
        },
      ],
    },

    // {
    //   path: "/403",
    //   name: '403',
    //   component: () => import("../pages/403"),
    // },
    {
      path: '*',
      redirect: '/404',
    },
    {
      path: '/e-print',
      name: 'e-print',
      meta: {
        title: '打印预览',
      },
      component: () => import('../components/common/e-print'),
    },

    {
      path: '/enquiryOrder',
      name: 'EnquiryOrder',
      meta: {
        title: '供应商报价对比表',
      },
      component: () => import('../pages/enquiryManage/enquiryOrder'),
    },

    {
      path: '/enquiryOption',
      name: 'EnquiryOption',
      meta: {
        title: '询比价采购方案',
      },
      component: () => import('../pages/enquiryManage/enquiryOption'),
    },
  ],
});
